"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var PaymentRecord_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentRecord = void 0;
const typeorm_1 = require("typeorm/browser");
const column_numeric_transformer_1 = require("../../transformers/column-numeric-transformer");
const accounting_document_1 = require("../accounting-documents/accounting-document");
const events_1 = require("../../events");
const column_date_transformer_1 = require("../../transformers/column-date-transformer");
const class_transformer_1 = require("class-transformer");
let PaymentRecord = PaymentRecord_1 = class PaymentRecord {
};
PaymentRecord.EVENTS = (0, events_1.makeEventsForClass)(PaymentRecord_1);
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], PaymentRecord.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: false,
        default: '',
    }),
    __metadata("design:type", String)
], PaymentRecord.prototype, "accountGid", void 0);
__decorate([
    (0, typeorm_1.Column)('date', {
        transformer: new column_date_transformer_1.ColumnDateTransformer(),
    }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], PaymentRecord.prototype, "date", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: false,
        default: '',
    }),
    __metadata("design:type", String)
], PaymentRecord.prototype, "referenceText", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: false,
        default: '',
    }),
    __metadata("design:type", String)
], PaymentRecord.prototype, "referenceNumber", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: true,
        array: true,
    }),
    __metadata("design:type", Array)
], PaymentRecord.prototype, "documentNumbers", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 3,
        name: 'currency',
    }),
    __metadata("design:type", String)
], PaymentRecord.prototype, "currency", void 0);
__decorate([
    (0, typeorm_1.Column)('numeric', {
        name: 'total',
        precision: 12,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], PaymentRecord.prototype, "amount", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: false,
        default: '',
    }),
    __metadata("design:type", String)
], PaymentRecord.prototype, "nameOther", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: false,
        default: '',
    }),
    __metadata("design:type", String)
], PaymentRecord.prototype, "accountOther", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: false,
        default: '',
    }),
    __metadata("design:type", String)
], PaymentRecord.prototype, "bicOther", void 0);
__decorate([
    (0, typeorm_1.Column)('json', {
        nullable: true,
        select: false,
    }),
    __metadata("design:type", Object)
], PaymentRecord.prototype, "rawData", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    __metadata("design:type", Date)
], PaymentRecord.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    __metadata("design:type", Date)
], PaymentRecord.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => accounting_document_1.AccountingDocument, (document) => document.payments),
    __metadata("design:type", Array)
], PaymentRecord.prototype, "documents", void 0);
PaymentRecord = PaymentRecord_1 = __decorate([
    (0, typeorm_1.Unique)('uq_payment', [
        'accountGid',
        'date',
        'referenceText',
        'referenceNumber',
        'currency',
        'amount',
        'nameOther',
        'accountOther',
        'bicOther',
    ]),
    (0, typeorm_1.Entity)('payment_record', { schema: 'payment' })
], PaymentRecord);
exports.PaymentRecord = PaymentRecord;
//# sourceMappingURL=payment-record.js.map